/* Oplayce — inclinaison 3D au survol (cartes produits, univers, vidéos courtes, galerie).
   Réglages : Paramètres du thème › Oplayce · Effets 3D (variables CSS --op-3d-tilt, --op-3d-angle). */
(function () {
  if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  if (document.body.classList.contains('op-3d-off')) return;
  var SEL = '.op-card__media, .op-panel, .op-reel, .product-media-container, .product__media-item .media, .op-3d__fallback-wrap';
  function tiltMax() { var v = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--op-3d-tilt')); return isNaN(v) ? 12 : v; }
  function media(el) { return el.matches('.op-3d__fallback-wrap') ? el.querySelector('img') : el.querySelector(':scope > img, :scope > video, :scope > a > img, :scope img, :scope video'); }
  function attach(el) {
    if (el.dataset.opTilt) return; el.dataset.opTilt = '1';
    var m = media(el); if (!m) return;
    var rect = null, raf = null, target = { x: 0, y: 0 };
    function apply() {
      raf = null;
      var max = tiltMax();
      m.style.transition = 'transform 0.18s ease-out';
      m.style.animationPlayState = 'paused';
      m.style.transform = 'perspective(1200px) rotateX(' + (target.y * max).toFixed(2) + 'deg) rotateY(' + (target.x * max).toFixed(2) + 'deg) scale(1.08)';
      el.style.setProperty('--op-shine-x', ((target.x + 1) * 50).toFixed(1) + '%');
      el.style.setProperty('--op-shine-y', ((target.y + 1) * 50).toFixed(1) + '%');
    }
    el.addEventListener('pointerenter', function () { rect = el.getBoundingClientRect(); el.classList.add('is-tilting'); });
    el.addEventListener('pointermove', function (e) {
      if (!rect) rect = el.getBoundingClientRect();
      target.x = ((e.clientX - rect.left) / rect.width - 0.5) * 2;   // -1 gauche … +1 droite
      target.y = -((e.clientY - rect.top) / rect.height - 0.5) * 2;  // +1 haut … -1 bas
      if (!raf) raf = requestAnimationFrame(apply);
    });
    el.addEventListener('pointerleave', function () {
      rect = null; el.classList.remove('is-tilting');
      m.style.transition = 'transform 0.6s ease';
      m.style.transform = ''; m.style.animationPlayState = '';
      setTimeout(function () { m.style.transition = ''; }, 650);
    });
  }
  function scan(root) { (root || document).querySelectorAll(SEL).forEach(attach); }
  scan();
  new MutationObserver(function (ms) { ms.forEach(function (x) { x.addedNodes.forEach(function (n) { if (n.nodeType === 1) scan(n); }); }); }).observe(document.body, { childList: true, subtree: true });
})();
